const translations = {
    label: 'Select Applicator'
};

export default translations;
